import React, { useCallback, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Tvl from '../../../../shared/Tvl';
import StakerCount from './SubComponent/StakerCount';
import { useTheme } from '../../../../hooks/ThemeProvider';
import { calculateAPR, calculateChildPoolAPR } from '../../../../utils/unifarmAprCalculator';
import ChildPoolApr from '../../../../shared/ChildPoolApr';
import { useStake } from '../../../../hooks/useStake';

function ChildPoolTableRow({ pool, index, onClaimRewards, onWithdrawBond }) {
    const { theme } = useTheme();
    const [totalStakedFormatted, setTotalStakedFormatted] = useState("0.00");
// console.log(pool, 'poolpoolpool___d');
    // Helper function to format creator fee
    const formatCreatorFee = (fee) => {
        if (!fee) return '0';
        return parseFloat(fee).toFixed(2);
    };
    const [tvlAmount, setTvlAmount] = useState(0);

    const {  getTotalStaked } = useStake();
    const fetchTotalStaked = useCallback(async () => {
        if (!pool?.contractAddress) return;
        try {
            const decimals = pool?.rootPoolId?.tokenDecimals || 18;
            const totalStaked = await getTotalStaked(
                pool?.contractAddress,
                decimals
            );
            setTotalStakedFormatted(totalStaked.totalStakedFormatted);
        } catch (error) {
            console.error("Failed to fetch total staked:", error);
        }
    }, [pool]);
    const formatStakingAmount = (amount) => {
        if (!amount) return '0';
        return parseFloat(amount).toLocaleString();
    };

    // Helper function to shorten address
    const shortenAddress = (address) => {
        if (!address) return 'N/A';
        return `${address.slice(0, 6)}...${address.slice(-4)}`;
    };

    // Helper function to determine status based on creation date
    const getPoolStatus = (expiryTimestamp) => {
        const currentTime = Math.floor(Date.now() / 1000);
        const expiryTime = Math.floor(new Date(expiryTimestamp).getTime() / 1000);

        if (currentTime > expiryTime) {
            return 'Expired';
        }
        return 'Active';
    };

    const status = getPoolStatus(pool?.rootPool?.metadata?.poolEndDate);
    useEffect(() => {
        if(pool.contractAddress){
            fetchTotalStaked();
        }
    }, [pool.contractAddress]);
    const ThreeDotsIcon = () => (
        theme === 'dark' ? (
            <img src="/assets/threedots.svg" alt="options" />
        ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M6.99935 7.58332C7.32152 7.58332 7.58268 7.32216 7.58268 6.99999C7.58268 6.67782 7.32152 6.41666 6.99935 6.41666C6.67718 6.41666 6.41602 6.67782 6.41602 6.99999C6.41602 7.32216 6.67718 7.58332 6.99935 7.58332Z" stroke="#000F2F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.99935 3.50001C7.32152 3.50001 7.58268 3.23884 7.58268 2.91668C7.58268 2.59451 7.32152 2.33334 6.99935 2.33334C6.67718 2.33334 6.41602 2.59451 6.41602 2.91668C6.41602 3.23884 6.67718 3.50001 6.99935 3.50001Z" stroke="#000F2F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.99935 11.6667C7.32152 11.6667 7.58268 11.4055 7.58268 11.0833C7.58268 10.7612 7.32152 10.5 6.99935 10.5C6.67718 10.5 6.41602 10.7612 6.41602 11.0833C6.41602 11.4055 6.67718 11.6667 6.99935 11.6667Z" stroke="#000F2F" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    );

    return (
        <div className="table_innner">
            <h4 className="one_sidee">{index + 1}</h4>
            <div className="under_table LASTTTABLE">
                <img
                    src={pool?.rootPool?.metadata?.logo || "/assets/default.svg"}
                    className="imgtable"
                    alt="pool"
                    height={20}
                    width={20}
                />
                <div>
                    <h6>
                        {pool?.rootPool?.metadata?.projectName ||
                            shortenAddress(pool.rootPoolAddress)}
                    </h6>
                    <h5>
                        {pool?.tagline
                            ? (pool.tagline.length > 15
                                ? pool.tagline.slice(0, 15) + '...'
                                : pool.tagline)
                            : shortenAddress(pool.contract)}
                    </h5>
                </div>
            </div>
            <h4><ChildPoolApr childPoolContractAddress={pool?.contractAddress} rootPoolAddress={pool?.rootPool?.metadata?.contractAddress} rootPoolEndDate={pool?.rootPool.metadata.poolEndDate} rootPoolRewardAmount={pool?.rootPool?.metadata?.rewardAmount} rootPoolStartDate={pool?.rootPool?.metadata?.createdAt}/></h4>
            <h4><Tvl contractAddress={pool?.contractAddress} poolType='childPool' tokenAddress={pool?.rootPool?.metadata?.rewardToken }/></h4>
            <h4>{totalStakedFormatted}</h4>
            <h4>{formatCreatorFee(pool.creatorFeePercent)}%</h4>
            <h4><StakerCount contractAddress={pool?.contractAddress} /></h4>
            <div className={status === 'Active' ? 'active' : 'expire'}>
                {status}
            </div>
            <div className="drop_table">
                <Dropdown>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <ThreeDotsIcon />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <div className="innner_side">
                            <Link
                                to={`/stakingpool?id=${pool?.id}`}
                                className="inner_Drop"
                            >
                                <div className="inner_more">
                                    <img src="/assets/view.svg" alt="view" />
                                    <h5>View Pool</h5>
                                </div>
                            </Link>
                            {/* {status === 'Expired' && (  */}
                                 <div className="inner_Drop" onClick={() => onClaimRewards(pool)}>
                                <div className="inner_more">
                                    <img src="/assets/claim.svg" alt="claim" />
                                    <h5>Claim Rewards</h5>
                                </div>
                            </div>
                            {/* )} */}
                            {status === 'Expired' && (
                                <div className="inner_Drop" onClick={() => onWithdrawBond(pool)}>
                                    <div className="inner_more">
                                        <img src="/assets/bond.svg" alt="withdraw" />
                                        <h5>Withdraw Bond</h5>
                                    </div>
                                </div>
                         )}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    );
}

export default ChildPoolTableRow;